// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1435":"3654c3ca","8915":"e80da2aa","9352":"5ab57526"}[chunkId] + ".chunk.css";
};